export const selectShowDemoBanner = (state) => state.globalBanner.showDemoBanner
export const selectMailboxesSyncing = (state) => state.globalBanner.mailboxesSyncing
